import { render, staticRenderFns } from "./AdvertisingStars.vue?vue&type=template&id=50bc9528&"
import script from "./AdvertisingStars.vue?vue&type=script&lang=js&"
export * from "./AdvertisingStars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports